/**
 * @file useCaptchaConfig.ts
 *
 * @fileoverview Hook to read captcha configuration from the backend.
 */
import { useConfig } from '~/jobiqo/context/config';

interface CaptchaConfig {
  registerApplicant: boolean;
  registerRecruiter: boolean;
  jobApplication: boolean;
  siteKey: string;
}

/**
 * Returns captcha settings from backend config (getAppConfig).
 * Falls back to disabled if config is not available.
 */
export function useCaptchaConfig(): CaptchaConfig {
  const { getConfigByName } = useConfig();
  const config = getConfigByName('captcha');

  if (!config?.value) {
    return {
      registerApplicant: false,
      registerRecruiter: false,
      jobApplication: false,
      siteKey: '',
    };
  }

  const values: Record<string, string> = {};
  for (const item of config.value) {
    if (typeof item === 'object' && 'key' in item && 'value' in item) {
      values[item.key as string] = item.value as string;
    }
  }

  return {
    registerApplicant: values.register_applicant === '1',
    registerRecruiter: values.register_recruiter === '1',
    jobApplication: values.job_application === '1',
    siteKey: values.site_key || '',
  };
}
